import React from 'react';
import { useNavigate } from 'react-router-dom';
import PricingTables from './PricingTable';
import { userAppContext } from '../../context/Context';
import { useAcademicApplication } from '../../hooks/useAcademicApplication';
import { useCheckoutFlow } from '../../hooks/useCheckoutFlow';

const pricings = [
  {
    title: 'Standard',
    licence: 'Web Explorer',
    registerText: 'Upgrade',
    moreInfo: '+ info',
    forWhom1: 'For for-profit researchers',
    forWhom2: 'and research teams',
    included:
      'Access the full database, including drugs, chemicals, and the latest findings, accessible through a user-friendly web platform.',
    price: '1,199 EUR / year',
    priceId: process.env.REACT_APP_STRIPE_STANDARD_PRICE_ID || 'price_test_standard_placeholder',
  },
  {
    title: 'Advanced',
    licence: 'API Access',
    registerText: 'Upgrade',
    moreInfo: '+ info',
    forWhom1: 'For academics, enterprises',
    forWhom2: 'and for-profit researchers',
    included:
      'Streamline your workflows by connecting the full database, including all the latest findings, with your existing systems via an API.',
    price: '1,999 EUR / year',
    priceId: process.env.REACT_APP_STRIPE_ADVANCED_PRICE_ID || 'price_test_advanced_placeholder',
  },
];

export function PricingCard({ title, licence, price, priceId, registerText, canSeePrices }) {
  const navigate = useNavigate();
  const { redirectToCheckout } = useCheckoutFlow();

  const handleButtonClick = async () => {
    if (canSeePrices) {
      await redirectToCheckout({
        title,
        priceId,
        quantity: 1,
      });
    } else {
      navigate('/Support');
    }
  };

  return (
    <div className="PricingCard-ac">
      <header>
        <p className="card-title">{title}</p>
        <p className="card-price">{licence}</p>
        {canSeePrices ? (
          <p className="card-price">{price}</p>
        ) : (
          <p className="card-price" style={{ opacity: 0.8 }}>
            Contact us for pricing
          </p>
        )}
      </header>
      <button className="btn-gradient-pink" onClick={handleButtonClick}>
        {canSeePrices ? registerText : 'Contact Us'}
      </button>
      <button className="btn-gradient-pink" onClick={() => navigate('/academic-plans')}>
        + info
      </button>
    </div>
  );
}

function RenderPricings() {
  const { isAuthenticated, user } = userAppContext();
  const { canSeePrices: canSeePricesFromHook } = useAcademicApplication(user?.email, isAuthenticated);

  // Use tag-based logic from hook
  const canSeePrices = canSeePricesFromHook();

  const scrollToPricingSection = () => {
    const pricingSection = document.getElementById('pricingSection');
    pricingSection.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="PricingApp">
      <div className="app-container">
        <div className="pricing-cards p-3 flex-row gap-4">
          {pricings.map(pricing => (
            <PricingCard key={pricing.title} {...pricing} canSeePrices={canSeePrices} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default RenderPricings;
